import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import React, { useState } from 'react';
import { ReactComponent as Arrow } from './arrow.svg';
import style from './block.module.scss';
import clsx from 'clsx';

const Inspector = React.lazy(() => import('./inspector.js'));

function Block({ breadcrumb, currentPage, articlesArchiveUrl = null, isCenterMobile }) {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();
    const Wrapper = isEditing ? 'div' : 'a';
    const [breadcrumbShow] = useState(breadcrumb || {});

    const parent =
        articlesArchiveUrl || breadcrumbShow.parent
            ? {
                  label: breadcrumbShow?.parent?.post_title ?? 'Articles',
                  url: breadcrumbShow?.parent?.url ?? articlesArchiveUrl,
              }
            : null;

    return (
        <BlockWrapper.Div className={style.block}>
            <ol className={clsx(style.breadcrumb, isCenterMobile && style.centerMobile)}>
                <li>
                    <Wrapper href="/">Accueil</Wrapper>
                </li>

                <Arrow className={style.arrow} />

                {parent && (
                    <>
                        <li>
                            <Wrapper href={parent.url}>{parent.label}</Wrapper>
                        </li>

                        <Arrow className={style.arrow} />
                    </>
                )}
                {currentPage && <li>{currentPage}</li>}
            </ol>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        isCenterMobile: smartProps.bool.withDefault(false),
    },
    setup: {
        title: "Fil d'ariane",
    },
});
